var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "1em",
    height: "1em",
    viewBox: "0 -48 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.499-24c0-2.032-.741-3.789-2.225-5.274-1.485-1.484-3.242-2.225-5.274-2.225v-5.041c3.437 0 6.387 1.232 8.847 3.693 2.461 2.46 3.693 5.41 3.693 8.847h-5.041zm9.962 0c0-4.844-1.7-8.965-5.097-12.364-3.399-3.397-7.52-5.097-12.364-5.097V-46.5c6.25 0 11.562 2.188 15.937 6.563S46.5-30.25 46.5-24h-5.039zm2.578 8.789c.704 0 1.289.234 1.758.703.468.468.703 1.054.703 1.757v8.79c0 .704-.235 1.289-.703 1.758-.469.468-1.054.703-1.758.703-11.719 0-21.738-4.159-30.058-12.481C5.659-22.301 1.5-32.32 1.5-44.039c0-.704.235-1.289.703-1.758.469-.468 1.054-.703 1.758-.703h8.79c.703 0 1.289.235 1.757.703.469.469.703 1.054.703 1.758 0 3.126.469 6.094 1.407 8.907.313 1.015.117 1.874-.586 2.577l-5.509 5.509c3.672 7.186 9.18 12.695 16.523 16.523l5.509-5.509c.703-.703 1.562-.899 2.577-.586 2.813.938 5.781 1.407 8.907 1.407z",
    fillRule: "nonzero",
    fill: "#000",
    stroke: "none"
  })));
}

export default SvgPhone;